import { render, staticRenderFns } from "./ListCandidatura.vue?vue&type=template&id=1a27d823"
import script from "./ListCandidatura.vue?vue&type=script&lang=js"
export * from "./ListCandidatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports